const invertedMessages = {
  'Loading users': 'external.common.userSkeleton.loadingUsers',
};

export default invertedMessages;
